import {useState} from 'react';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import NamedLocationsEditLookupCoords from './NamedLocationsEditLookupCoords';
import NamedLocationsEditLookupAddress from './NamedLocationsEditLookupAddress';

export default function NamedLocationsEditLookup(props) {
    //console.debug("RTS Break NamedLocationsEditLookup");

    const [tabIndex, setTabIndex] = useState(0);


    const handleChange = (e, curIndex) => {
        setTabIndex(curIndex);
    };

    
    return (
        <>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb:1 }}>
                <Tabs value={tabIndex} onChange={handleChange}>
                    <Tab label="Address" value={0}  />
                    <Tab label="Coordinates" value={1} />
                </Tabs>
            </Box>

            {
            tabIndex === 1
            ?
            <>
            <Box>
                <NamedLocationsEditLookupCoords setSearchDataFx={props.setSearchDataFx} setShowLookupModalFx={props.setShowLookupModalFx} />
            </Box>
            </>
            :
                <>
                <Box>
                    <NamedLocationsEditLookupAddress setSearchDataFx={props.setSearchDataFx} setShowLookupModalFx={props.setShowLookupModalFx} />
                </Box>
                </>
            }
        </>
    );
}